export interface QueueUserModel {
    userId: number;
    queueId: number;
}
